import store, { useAppSelector } from "src/redux/store";

export type UserTypeKey =
  | "INDIVIDUAL"
  | "ORGANIZATION"
  | "IMPLEMENTING_OFFICER";

/** Call this anywhere — inside or outside React components */
export const getUserType = (): UserTypeKey => {
  const userType = store.getState().root.user.data.userType;
  if (userType === "INDIVIDUAL") return "INDIVIDUAL";
  if (userType === "ORGANIZATION") return "ORGANIZATION";
  return "IMPLEMENTING_OFFICER";
};

/** Use inside React components for reactive updates */
export const useUserType = () => {
  const { userType, state, division, firstName } = useAppSelector(
    (state) => state.root.user.data
  );

  const isNodal = userType === "INDIVIDUAL";
  const isEntity = userType === "ORGANIZATION";
  const isImplementingOfficer = !isNodal && !isEntity;

  const resolvedType: UserTypeKey = isNodal
    ? "INDIVIDUAL"
    : isEntity
    ? "ORGANIZATION"
    : "IMPLEMENTING_OFFICER";

  const label = isNodal
    ? `Nodal Officer: ${state}`
    : isEntity
    ? `Entity: ${firstName}`
    : `Implementing Officer: ${division}`;

  return {
    userType: resolvedType,
    isNodal,
    isEntity,
    isImplementingOfficer,
    label,
  };
};
